import React from 'react';
import { expertEntitlementsService } from '@services/expert-entitlements.service.ts';
import { getAdminExpertPlans } from '@services/payment.service.ts';
import { PlanFeatureMatrix } from './PlanFeatureMatrix';

export const ExpertPlanFeatureMatrixTab: React.FC = () => (
  <PlanFeatureMatrix
    fetchPlans={() => getAdminExpertPlans(true)}
    fetchFeatures={() => expertEntitlementsService.listFeatures()}
    fetchPlanFeatures={(planId) => expertEntitlementsService.getPlanFeatures(planId)}
    setPlanFeatures={(planId, keys) => expertEntitlementsService.setPlanFeatures(planId, keys)}
  />
);
